import React, { useEffect } from 'react';
import DeviceList from '../organisms/DeviceList';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { checkAuthState } from '../../redux/slices/authSlice';
import Spinner from 'react-bootstrap/Spinner';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ThunkDispatch, Action } from '@reduxjs/toolkit';

const DevicesPage: React.FC = () => {
  const dispatch = useDispatch<ThunkDispatch<RootState, void, Action>>()
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(checkAuthState());
  }, [dispatch]);

  if (!isAuthenticated) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Devices</h1>
        <Link to="/devices/connect">
          <Button variant="primary">Connect New Device</Button>
        </Link>
      </div>
      <DeviceList />
    </div>
  )
};

export default DevicesPage;
